import { SelectableButton } from 'foundations-components/transitional/components/SelectableButton';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import UsageTracker from '../../utils/UsageTracker';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { useCurrentLearningInterest, useWizardCategoriesMap } from '../../features/wizard/wizardQueries';
import { HUBSPOT_SOFTWARE_INDEX } from '../../features/wizard/wizardTypes';
import { Logo } from 'foundations-components/transitional/components/Logo';
import { WizardList } from './WizardList';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledFormattedReactMessage = styled(FormattedReactMessage).withConfig({
  displayName: "WizardCategories__StyledFormattedReactMessage"
})(["display:flex;align-items:center;justify-content:center;gap:6px;"]);
const WizardCategories = ({
  onOptionSelect
}) => {
  const {
    selectedCategoryGroup
  } = useCurrentLearningInterest();
  const {
    wizardCategoryMap,
    isLoading
  } = useWizardCategoriesMap();
  const getLevel1Label = index => {
    return index === HUBSPOT_SOFTWARE_INDEX ?
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(StyledFormattedReactMessage, {
      "aria-label": I18n.text('learningCenter.categories.hubspotSoftware'),
      message: "learningCenter.wizard.hubspotsoftware",
      options: {
        imageElement: /*#__PURE__*/_jsx(Logo, {
          alt: "hubspot",
          name: "hubspot-wordmark",
          width: 62
        })
      }
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: `learningCenter.filtersGroups.${index}`
    });
  };
  const trackCategoryClick = category => {
    UsageTracker.track('wizardInteraction', {
      action: 'wizard-click-category',
      categoryClicked: category
    });
  };
  const trackSubCategoryClick = subcategory => {
    UsageTracker.track('wizardInteraction', {
      action: 'wizard-click-sub-category',
      categoryClicked: subcategory
    });
  };
  const renderCategoryList = () => {
    return /*#__PURE__*/_jsx(WizardList, {
      children: !selectedCategoryGroup ? Object.keys(wizardCategoryMap).map(category => /*#__PURE__*/_jsx(SelectableButton, {
        block: true,
        onClick: () => trackCategoryClick(category),
        onSelectedChange: () => {
          onOptionSelect(category);
        },
        selected: false,
        title: getLevel1Label(category)
      }, category)) : Object.values(wizardCategoryMap[selectedCategoryGroup]).map(category => /*#__PURE__*/_jsx(SelectableButton, {
        block: true,
        onClick: () => trackSubCategoryClick(category),
        onSelectedChange: () => {
          onOptionSelect(category);
        },
        selected: false,
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `learningCenter.topFilters.cat.${category}`
        })
      }, category))
    });
  };
  return !isLoading ? renderCategoryList() : /*#__PURE__*/_jsx(LoadingSpinner, {
    size: 'sm'
  });
};
export default WizardCategories;